import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "preview"];
  static values = { url: String };

  connect() {
    this.update();
  }

  update() {
    clearTimeout(this._timeout);
    this._timeout = setTimeout(() => this.fetchPreview(), 300);
  }

  fetchPreview() {
    const title = this.inputTarget.value.trim();
    if (!title) {
      this.previewTarget.innerHTML = "";
      return;
    }

    const url = `${this.urlValue}?title=${encodeURIComponent(title)}`;
    fetch(url, { headers: { "Accept": "application/json" } })
      .then(response => response.json())
      .then(data => {
        if (data.valid) {
          this.previewTarget.innerHTML = `<span class="text-success">Codice: <strong>${data.code}</strong></span>`;
        } else {
          this.previewTarget.innerHTML = `<span class="text-warning">\u26A0 Nessun codice riconosciuto nel titolo</span>`;
        }
      });
  }
}
